import React from 'react';
import GalleryGridEditor from '../GalleryGridEditor';
import PageToggleBanner from './PageToggleBanner';
import { updateMedia } from '../../services/api';

function MediaTab({
  profileSettings,
  setProfileSettings,
  hiddenSections,
  handleToggleSection,
  // Videos
  mediaItems,
  newMedia,
  setNewMedia,
  handleAddMedia,
  handleDeleteMedia,
  // Photos
  photos,
  setPhotos,
  renderPhotoSlot,
  // Save
  showMessage,
}) {
  return (
    <>
      {/* REVIEW: extracted to PageToggleBanner */}
      <PageToggleBanner
        label="Media/Gallery Page"
        enabled={!hiddenSections.includes('media')}
        onToggle={() => handleToggleSection('media')}
      />

      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Layout</h2>
          <p>
            Show your photo gallery and videos together, split them into separate pages, or only use
            one
          </p>
        </div>
        <div className="media-layout-options">
          {[
            { id: 'together', label: 'Both Together', desc: 'Photos and videos on one page' },
            {
              id: 'separate',
              label: 'Separate Pages',
              desc: 'Gallery and Videos as separate nav items',
            },
            { id: 'gallery_only', label: 'Gallery Only', desc: 'Only show your photo gallery' },
            { id: 'videos_only', label: 'Videos Only', desc: 'Only show your video reels' },
          ].map((opt) => (
            <button
              key={opt.id}
              className={`media-layout-option${(profileSettings.media_mode || 'together') === opt.id ? ' active' : ''}`}
              onClick={() => setProfileSettings({ ...profileSettings, media_mode: opt.id })}
            >
              <span className="media-layout-option-label">{opt.label}</span>
              <span className="media-layout-option-desc">{opt.desc}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="settings-card">
        <div className="settings-card-header">
          <h2>Videos</h2>
          <p>YouTube videos and performance reels</p>
        </div>
        {mediaItems.length > 0 && (
          <div className="media-list">
            {mediaItems.map((item) => (
              <div key={item.id} className="media-item-display">
                {item.embed_url && (
                  <div className="media-preview">
                    <iframe
                      width="100%"
                      height="200"
                      src={item.embed_url}
                      title={item.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                )}
                <div className="media-item-info">
                  <strong>{item.title || 'Untitled'}</strong>
                  <button className="btn-remove-small" onClick={() => handleDeleteMedia(item.id)}>
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        <div className="add-item-form">
          <h4>Add Video</h4>
          <div className="form-group">
            <label>Video Title</label>
            <input
              type="text"
              value={newMedia.title}
              onChange={(e) => setNewMedia({ ...newMedia, title: e.target.value })}
              placeholder="Defying Gravity - Wicked"
            />
          </div>
          <div className="form-group">
            <label>YouTube URL *</label>
            <input
              type="text"
              value={newMedia.url}
              onChange={(e) => setNewMedia({ ...newMedia, url: e.target.value })}
              placeholder="https://www.youtube.com/watch?v=..."
            />
          </div>
          <button className="btn-add" onClick={handleAddMedia}>
            + Add Video
          </button>
        </div>
      </div>

      {renderPhotoSlot(
        'gallery',
        'Photo Gallery',
        'Headshots, production stills, and behind-the-scenes',
        999
      )}

      {/* Gallery Grid Editor */}
      {photos.filter((p) => p.slot === 'gallery').length > 0 && (
        <div className="settings-card">
          <div className="settings-card-header">
            <h2>Gallery Layout</h2>
            <p>Drag dividers to resize columns. Drag photos to rearrange.</p>
          </div>
          <GalleryGridEditor
            photos={photos
              .filter((p) => p.slot === 'gallery')
              .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))}
            config={profileSettings.gallery_grid_config}
            onChange={(newConfig) =>
              setProfileSettings({ ...profileSettings, gallery_grid_config: newConfig })
            }
            onReorder={async (updates) => {
              try {
                await Promise.all(
                  updates.map((u) => updateMedia(u.id, { sort_order: u.sort_order }))
                );
                setPhotos((prev) => {
                  const updated = [...prev];
                  updates.forEach((u) => {
                    const photo = updated.find((p) => p.id === u.id);
                    if (photo) photo.sort_order = u.sort_order;
                  });
                  return updated;
                });
              } catch (error) {
                showMessage('error', 'Failed to reorder photos');
              }
            }}
          />
        </div>
      )}
    </>
  );
}

export default MediaTab;
